import { IAnyType, Instance, SnapshotIn, SnapshotOut, types } from "mobx-state-tree"
import { IUser } from "@cruisen/contract"

export const UserModel = types.model("User").props({
  id: types.identifier,
  profileId: types.maybeNull(types.number),
  email: types.string,
  firstName: types.string,
  lastName: types.string,
  phoneNumber: types.string,
  ageGroup: types.string,
  avatar: types.maybeNull(types.string),
  dob: types.optional(types.string, ""),
  referralCode: types.maybeNull(types.string),
  agentCode: types.maybeNull(types.string),
  pirateName: types.maybeNull(types.string),
  invitedBy: types.maybeNull(types.string),
  loyaltyTokensPending: types.maybeNull(types.number),
  loyaltyTokensAvailable: types.maybeNull(types.number),
  created: types.optional(types.integer, () => Date.now()),
  updated: types.optional(types.integer, () => Date.now()),
  lastActive: types.optional(types.integer, () => Date.now()),
  isSuperAdmin: types.optional(types.boolean, false),
  subscriptionCouponCode: types.maybeNull(types.string),
} as { [P in keyof IUser]: IAnyType })

export type User = Instance<typeof UserModel>
export type UserSnapshotOut = SnapshotOut<typeof UserModel>
export type UserSnapshotIn = SnapshotIn<typeof UserModel>
export const createUserDefaultModel = () => types.optional(UserModel, {})
